import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { createContext, useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
export var KitContext = /*#__PURE__*/createContext({
  state: {},
  step: 0,
  totalSteps: 0
});
export var KitContextProvider = function KitContextProvider(_ref) {
  var children = _ref.children,
      kit = _ref.kit,
      initialState = _ref.initialState,
      totalSteps = _ref.totalSteps;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      step = _useState2[0],
      setStep = _useState2[1];

  var _useState3 = useState(initialState),
      _useState4 = _slicedToArray(_useState3, 2),
      state = _useState4[0],
      setState = _useState4[1];

  var setAndScroll = useCallback(function (newStep) {
    setStep(newStep);
    window.scrollTo({
      left: 0,
      top: 36
    });
  }, []);
  return /*#__PURE__*/_jsx(KitContext.Provider, {
    value: {
      kit: kit,
      state: state,
      setState: setState,
      step: step,
      setStep: setAndScroll,
      totalSteps: totalSteps
    },
    children: children
  });
};
var ImageType = PropTypes.shape({
  alt: PropTypes.string,
  src: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number
});
var VideoType = PropTypes.shape({
  src: PropTypes.string,
  subtitleUrl: PropTypes.string,
  poster: ImageType
});
KitContextProvider.propTypes = {
  children: PropTypes.node,
  kit: PropTypes.shape({
    absoluteUrl: PropTypes.string,
    compareAtPrice: PropTypes.number,
    cta: PropTypes.string,
    description: PropTypes.string,
    gender: PropTypes.string,
    image: ImageType,
    imageMobile: ImageType,
    price: PropTypes.number,
    subtitle: PropTypes.string,
    title: PropTypes.string,
    video: VideoType,
    videoMobile: VideoType
  }),
  initialState: PropTypes.arrayOf(PropTypes.shape({})),
  totalSteps: PropTypes.number
};